import { Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef, inject } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { ContentComponent } from '../components/content/content';
import { NavbarComponent } from '../components/navbar/navbar';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { CoreSidebarComponent } from '../../../@core/components/core-sidebar/core-sidebar';
import { MenuComponent } from '../components/menu/menu';
import { FooterComponent } from '../components/footer/footer';

@Component({
    selector: 'vertical-layout',
    templateUrl: './vertical-layout.html',
    styleUrl: './vertical-layout.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [NgTemplateOutlet, ContentComponent, NavbarComponent, NgClass, DefaultClassDirective, CoreSidebarComponent, MenuComponent, FooterComponent]
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  private _coreConfigService = inject(CoreConfigService);
  private _elementRef = inject(ElementRef);

  coreConfig: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor() {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(true);
    this._unsubscribeAll.complete();
  }
}
